import React from 'react';
import FormControl from 'react-bootstrap/FormControl';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';

const CustomSearch = (props) => {
    const [ searchValue, setSearchValue ] = React.useState("");

    const handleChange = e => {
        setSearchValue(e.target.value);
        props.onSearch(e.target.value);
        if(props.callback){
            props.callback();
        }
    }

    const clearSearchValue = e => {
        e.preventDefault();
        setSearchValue("");
        props.onSearch("");
        if(props.callback){
            props.callback();
        }
    }

    return (
        <InputGroup className={props.className}>
            <InputGroup.Prepend>
            {
                searchValue
                ?
                <Button className="py-1 px-2" variant="outline-secondary" onClick={clearSearchValue}>
                    <i className="material-icons py-0" style={{fontSize : "16px"}}>clear</i>
                </Button>
                :
                <InputGroup.Text>
                    <i className="material-icons" style={{fontSize : "18px"}}>search</i>
                </InputGroup.Text>
            }
            </InputGroup.Prepend>
            <FormControl
                placeholder={props.placeholder || "Search"}
                aria-label="Search Table"
                aria-describedby="table-search-input"
                type={props.text}
                onChange={handleChange}
                value={searchValue}
                className="h-100"
            />
        </InputGroup>
    );
};

CustomSearch.defaultProps = {
    type: "text"
}

export default CustomSearch;